export const store = (key: string, value: any) => {
  localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : String(value))
}

export const read = (key: string): any | string => {
  const _value = localStorage.getItem(key)

  if (_value) {
    try {
      return JSON.parse(_value)
    } catch (e) {
      return _value
    }
  }
}

export const remove = (key: string) => {
  localStorage.removeItem(key)
}
